module.exports = __webpack_public_path__ + "assets/img/40de36e7e95dbed3c760015ea8ac5603.svg";